export default "__VITE_ASSET__Cp3mtWyi__"